import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import Datetime from 'components/Shared/Datetime';
import MessageDialog from 'components/Shared/MessageDialog';

const styles = theme => ({
    rootTable: {
        width: '100%',
        overflowX: 'auto',
        overFlowY: 'auto'
    },
    cellAnomalie: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.common.white
    }
});

const anomalieExpeditionLabels = [
    "",
    "Pas de date d'expédition",
    "Plusieurs dates d'expédition",
    "Etat pas expédié",
    "Palette MONO",
    "Monne 1 et 2"
];

class ColisLogistiqueQualification extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showWarning: false
        };
    }

    componentDidUpdate(prevProps) {
        const { warningSelectionComplete, reclamation, colisLogistique } = this.props;
        
        if (warningSelectionComplete && prevProps.reclamation.colis.length !== this.props.reclamation.colis.length) {
            // Vérifier si tous les colis sont sélectionnés
            if ((reclamation.colis.length === colisLogistique.length) && (colisLogistique.length > 0)) {
                this.setState({ showWarning: true });
            }
        }
    }

    removeOldestSelectedColis = () => {
        const { reclamation, onRemoveColis } = this.props;
        
        if (reclamation.colis.length > 0) {
            // Le plus ancien est le premier dans la liste
            const oldestColis = reclamation.colis[0];
            onRemoveColis(oldestColis.colisId);
        }
        
        this.setState({ showWarning: false });
    }

    handleChange = (event, value) => {
        const { reclamation, onAddColis, onRemoveColis, typeAnomalie } = this.props;
        
        // Vérifier si le colis est déjà sélectionné
        if (reclamation.colis.find(c => c.colisId === value)) {
            onRemoveColis(value);
        } else {
            onAddColis(value, typeAnomalie);
        }
    }

    render() {
        const { classes, colisLogistique, reclamation, warningSelectionComplete, closeAddReclamationDialog } = this.props;
        const { showWarning } = this.state;

        return (
            <React.Fragment>
                {warningSelectionComplete && (
                    <MessageDialog
                        ouvert={showWarning}
                        init={false}
                        titre="Attention"
                        contenu={"Merci de choisir la qualification \"Aucun Colis arrivé\" de la catégorie \"Commande pas arrivée\", si vous sélectionnez tous les colis\nou modifier votre sélection"}
                        texteNOK={"Abandonner"}
                        texteOK="Continuer"
                        onNOK={closeAddReclamationDialog}
                        onOK={this.removeOldestSelectedColis}
                    />
                )}
                <Paper className={classes.rootTable}>
                    <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Numéro tracking</TableCell>
                            <TableCell>Numéro SSCC</TableCell>
                            <TableCell>Numéro support</TableCell>
                            <TableCell>Recepissé</TableCell>
                            <TableCell>Date expédition logistique</TableCell>
                            <TableCell>Anomalie d'expédition</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {colisLogistique.map(c => {
                            const colisAnomalie = reclamation.colis.find(ca => ca.colisId === c.id);
                            const className = colisAnomalie ? classes.cellAnomalie : undefined;

                            return (
                                <TableRow hover key={c.id} onClick={event => this.handleChange(event, c.id)}>
                                    <TableCell className={className}>{c.numeroTracking}</TableCell>
                                    <TableCell className={className}>{c.numeroSSCC}</TableCell>
                                    <TableCell className={className}>{c.numeroSupport}</TableCell>
                                    <TableCell className={className}>{c.recepisse}</TableCell>
                                    <TableCell className={className}>
                                        {c.dateExpedition && (<Datetime withTime datetime={c.dateExpedition} />)}
                                    </TableCell>
                                    <TableCell className={className}>{anomalieExpeditionLabels[c.anomalieExpedition]}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </Paper>
            </React.Fragment>
        );
    }
}

ColisLogistiqueQualification.propTypes = {
    classes: PropTypes.object.isRequired,

    reclamation: PropTypes.object.isRequired,
    colisLogistique: PropTypes.array.isRequired,
    warningSelectionComplete: PropTypes.bool,

    closeAddReclamationDialog: PropTypes.func.isRequired,
    onAddColis: PropTypes.func.isRequired,
    onRemoveColis: PropTypes.func.isRequired,
    typeAnomalie: PropTypes.number.isRequired
};

export default withStyles(styles)(ColisLogistiqueQualification);